import Vue from 'vue';
import VueRouter from 'vue-router';

import Layout from '@/components/template/layout/Layout';
import Login from '@/components/pages/login/Login';
import RecoveryPassword from '@/components/pages/login/RecoveryPassword';
import ForgotPassword from '@/components/pages/login/ForgotPassword';
import AccountExpired from '@/components/pages/login/AccountExpired';
import Provider from '@/components/pages/provider/SelectProvider';
import Unauthorized from '@/components/template/unauthorized/Unauthorized';
import Main from '@/components/pages/main/Main';
import PatientsList from '@/components/pages/patients/PatientsList';
import PatientSummary from '@/components/pages/patients/PatientSummary';
import Patient from '@/components/pages/patients/Patient';
import UserService from '@/services/user.service';
import GeneralNotes from '@/components/pages/patients/GeneralNotes';
import PatientAsam from '@/components/pages/patients/PatientAsam';
import ContactsList from '@/components/pages/patients/contacts/ContactsList';
import Contacts from '@/components/pages/patients/contacts/Contact';
import Insurance from '@/components/pages/patients/insurances/InsurancesList';
import InsuranceDetails from '@/components/pages/patients/insurances/Insurance';
import Clinical from '@/components/pages/clinical/Clinical';
import ClinicalDashBoard from '@/components/pages/clinical/Dashboard';
import ClinicalNotes from '@/components/pages/clinical/ClinicalNotes';
import ClinicalAsam from '@/components/pages/clinical/ClinicalAsam';
import ClinicalPatientInfo from '@/components/pages/clinical/PatientInfo';
import AccessDenied from '@/components/template/unauthorized/AccessDenied';
import AllergiesList from '@/components/pages/patients/allergies/AllergiesList';
import Allergy from '@/components/pages/patients/allergies/Allergy';
import VitalSign from '@/components/pages/clinical/vitalsign/VitalSign';
import VitalSignList from '@/components/pages/clinical/vitalsign/VitalSignList';

import MedicationsList from '@/components/pages/clinical/medications/MedicationsList';
import Medications from '@/components/pages/clinical/medications/Medications';

import Schedule from '@/components/pages/schedule/schedule_sample';
import AdmissionList from '@/components/pages/admission/AdmissionList';
import AdmissionAdd from '@/components/pages/admission/Admission';
import AdmissionClinical from '@/components/pages/admission/AdmissionClinical';
import ScheduleEditor from '@/components/pages/schedule/schedule-editor';
import ChartReviewClinical from '@/components/pages/chartreview/ClinicalChartReview';
import ChartReviewPatient from '@/components/pages/chartreview/PatientChartReview';
import Transfer from '@/components/pages/Transfer/transfer';
import Discharge from '@/components/pages/Discharge/discharge';
import PatientDischargesListing from '@/components/pages/Discharge/DischargesListing';
import Diagnosis from '@/components/pages/patients/Diagnosis';
import ClaimBatch from '@/components/pages/claimbatch/claimbatchList';
import ClaimBatchSummary from '@/components/pages/claimbatch/claimbatchSummary';
import InsuranceSetupList from '@/components/pages/setup/insuranceCompanies/insuranceSetupList.vue';
import InsuranceSetup from '@/components/pages/setup/insuranceCompanies/insuranceSetup.vue';
import DoctorSetup from '@/components/pages/setup/facilities/doctorSetup.vue';
import Doctor from '@/components/pages/setup/facilities/doctor.vue';
import ReportBuilder from '@/components/MedEZComponents/report/ReportBuilder';
import UserTemplateHeaderList from '@/components/pages/setup/users/userTemplate/userTemplateHeaderList.vue';
import UserRole from '@/components/pages/setup/users/userTemplate/userRoleDetails.vue';
import UserHeaderList from '@/components/pages/setup/users/user/userHeaderList.vue';
import UserHeader from '@/components/pages/setup/users/user/userHeader.vue';
import MethodNotAllowed from '@/components/template/notallowed/methodnotallowed';
import CreateClearingHF from '@/components/pages/claimbatch/createclearinghousefile';
import ManageClaimBatches from '@/components/pages/claimfile/manageclaimbatches';

import HcpcsCptRevCode from '@/components/pages/setup/billing/cptList';
import ModifiersList from '@/components/pages/setup/billing/modifiersList';
import PlaceofServiceList from '@/components/pages/setup/billing/placeofserviceList';
import PlaceofService from '@/components/pages/setup/billing/placeofservice';
import CPT from '@/components/pages/setup/billing/cpt';
import Modifiers from '@/components/pages/setup/billing/modifier';
import EmployeeTypeList from '@/components/pages/setup/employees/employeetypeList';
import EmployeeType from '@/components/pages/setup/employees/employeeType';
import ValueCodeList from '@/components/pages/setup/billing/valuecodeList';
import ValueCode from '@/components/pages/setup/billing/valuecode';
import RoomsList from '@/components/pages/setup/facilities/roomsList.vue';
import Rooms from '@/components/pages/setup/facilities/rooms.vue';
import BuildingList from '@/components/pages/setup/facilities/buildingList.vue';
import Building from '@/components/pages/setup/facilities/building.vue';

import EmployeeCredentialList from '@/components/pages/setup/employees/employeecredentialList';
import EmployeeCredential from '@/components/pages/setup/employees/employeecredential';

import EmployeeList from '@/components/pages/setup/employees/employeeList';
import Employee from '@/components/pages/setup/employees/employee';

import AppoinmentTypeList from '@/components/pages/setup/scheduler/appoinmentType/appoinmentTypeList';
import AppoinmentType from '@/components/pages/setup/scheduler/appoinmentType/appoinmentType';

import CalendarResourcesList from '@/components/pages/setup/scheduler/calendarResources/calendarResourcesList';
import CalendarResources from '@/components/pages/setup/scheduler/calendarResources/calendarResources';
import ReportClinicalNotes from '@/components/pages/reports/notes/rClinicalNotes';
import DocumentManagementList from '@/components/pages/patients/PatientDocumentList';
import DocumentManagement from '@/components/pages/patients/PatientDocument';

import ePharmacyPatient from '@/components/pages/ePharmacy/ePharmacyPatient';
import ePharmacyClinical from '@/components/pages/ePharmacy/ePharmacyClinical';
import DailyNotesList from '@/components/pages/clinical/dailynote/DailyNotesList';
import DailyNote from '@/components/pages/clinical/dailynote/DailyNote';
import ReportList from '@/components/pages/reports/ReportList'
import PowerBILayout from '@/components/pages/reports/powerbi/PowerBILayout'
import PowerBIReport from '@/components/pages/reports/powerbi/PowerBIReport'
import DailyServiceCharge from '@/components/pages/reports/dailyServiceCharge'
import DailyServiceLog from '@/components/pages/reports/dailyServiceLog'
import EmployeeInbox from '@/components/pages/clinical/employeeinbox/EmployeeInbox'

import GroupNotes from '@/components/pages/groupnotes/GroupNotes';
//import GroupNotesDashBoard from '@/components/pages/groupnotes/GroupNotesDashboard';
import GroupNotesAccordion from '@/components/pages/groupnotes/GroupNotesAccordion';

import LogNotesList from '@/components/pages/clinical/lognotes/LogNotesList';
import LogNote from '@/components/pages/clinical/lognotes/LogNotes';
import SchedulerDB from '@/components/pages/schedule/schedulerDB';
import AppointmentDashBoard from '@/components/pages/appointment/Dashboard';
import SchedulerNotes from '@/components/pages/appointment/SchedulerNotes';
import PatientActivitiesList from '@/components/pages/patients/activities/PatientActivitiesList';
import PatientActivity from '@/components/pages/patients/activities/EditPatientActivity';
import IncidentReport from '@/components/pages/incidentReport/IncidentReport'
import IncidentReportContent from '@/components/pages/incidentReport/IncidentReportContent'
import DrugList from '@/components/pages/setup/drugs/drugList'
import Drug from '@/components/pages/setup/drugs/drug'
import PatientContactsRep from '@/components/pages/reports/patientContactsRep'
import PatientAllergyRep from '@/components/pages/reports/PatientAllergyRep'
import PatientInsurancesRep from '@/components/pages/reports/PatientInsurancesRep'
import ICRMultipleViewRep from '@/components/pages/reports/ICRMultipleViewRep'
import SpecialPrecautionsRep from '@/components/pages/reports/SpecialPrecautionsRep'
import schedulerDailyFiltersRep from '@/components/pages/reports/schedulerDailyFiltersRep'
import ReportEmployeeCaseLoad from '@/components/pages/reports/employeeCaseLoad';
import IncidentWorkflow from '@/components/pages/incidentWorkflow/IncidentWorkflow'
import DcsList from '@/components/pages/dcs/dcsListing'
import Dcs from '@/components/pages/dcs/dcs'
import TPBase from '@/components/pages/treatmentplanBase/treatmentplanbase'
import WyTreatmentPlanList from '@/components/pages/wytreatmentplan/treatmentplanList'
import WyTreatmentPlan from '@/components/pages/wytreatmentplan/treatmentplan'
import MdTreatmentPlanList from '@/components/pages/mdtreatmentplan/treatmentplanList'
import MdTreatmentPlan from '@/components/pages/mdtreatmentplan/treatmentplan'
import SchedulerClinical from '@/components/pages/clinical/scheduler/SchedulerClinical'
import Appointments from '@/components/pages/patients/appointments/Appointments'
import PatientAlertList from '@/components/pages/patients/alerts/PatientAlertList'
import EditPatientAlert from '@/components/pages/patients/alerts/EditPatientAlert'



import ClinicalNotesContainer from '@/components/pages/clinicalNotesContainer/ClinicalNotesContainer';
import AppointmentEditor from '@/components/pages/appointment/AppointmentEditor'
import ScheduleDBAdmission from '@/components/pages/schedule/scheduleDB-admission'
import EditSpecialPrecautions from '@/components/pages/patients/specialPrecautions/EditSpecialPrecautions.vue';
import EditMarsAlert from '@/components/pages/nurses/mars/EditMarsAlert.vue';


import AllergySetupList from '@/components/pages/setup/allergy/allergySetupList'
import AllergySetup from '@/components/pages/setup/allergy/allergySetup'
import MarsList from '@/components/pages/nurses/mars/marsList'
import MarsPatientMed from '@/components/pages/nurses/mars/marsPatientMed'
import AdmissionsViewRep from '@/components/pages/reports/admissionsViewRep'
import patientMarsRep from '@/components/pages/reports/patientMarsRep'
import PatientAlertFiltersRep from '@/components/pages/reports/PatientAlertFiltersRep'
import PatientActivityFiltersRep from '@/components/pages/reports/PatientActivityFiltersRep'
import PatientMedicationFiltersRep from '@/components/pages/reports/PatientMedicationFiltersRep'
import PatientMarsAlertsRep from '@/components/pages/reports/PatientMarsAlertsRep'
import AuditListing from '@/components/pages/audit/AuditListing.vue';
import AuditSettingListing from '@/components/pages/audit/AuditSettingListing.vue';

import PostPayment from '@/components/pages/postPayment/PostPayment'

import DCSView from '@/components/pages/dcs/dcsview'
import DcsUpload from '@/components/pages/dcs/dcsUpload';
import ClaimBatchStatus from '../components/pages/claimbatch/claimBatchStatus.vue';

import CustomExportsList from '@/components/pages/reports/customExports/customExportsList'
import CustomExports from '@/components/pages/reports/customExports/customExports'
import CustomReports from '@/components/pages/reports/customReports/customReports'
import PatientClaim from '@/components/pages/patients/claim/PatientClaimList'
import Claim from '@/components/pages/patients/claim/Claim'
import ChargeSheet from '@/components/pages/chargeSheet/ChargeSheet'
import ChargeSheetDetail from '@/components/pages/chargeSheet/ChargeSheetDetail'
import MedicationInbox from '@/components/pages/nurses/medicationinbox/MedicationInbox'
import StandingOrders from '@/components/pages/clinical/medications/StandingOrders/StandingOrders.vue';


import IniUsers from '@/components/pages/initialization/iusers'
import IniUsersList from '@/components/pages/initialization/iusersList'
import IniReferralList from '@/components/pages/initialization/ireferralList'
import IniReferral from '@/components/pages/initialization/ireferral'
import IniCompany from '@/components/pages/initialization/icompanies'
//import IniProviders from '@/components/pages/initialization/iproviders'
//import IniRoles from '@/components/pages/initialization/iroles'

import IniPrograms from '@/components/pages/initialization/iprograms'
import IniNotes from '@/components/pages/initialization/inotes'
import IniTherapies from '@/components/pages/initialization/itherapies'
import IniAppTypes from '@/components/pages/initialization/iapptypes'
import IniReviewSubmit from '@/components/pages/initialization/ireviewsubmit'
import IniInsurance from '@/components/pages/initialization/iinsurance'
import PatientFaceSheetViewRep from '@/components/pages/reports/PatientFaceSheetViewRep.vue';
import PatientFaceSheetByAdmissionRep from '@/components/pages/reports/PatientFaceSheetByAdmissionRep.vue';


import OrdersList from '@/components/pages/clinical/orders/OrdersList'
import Orders from '@/components/pages/clinical/orders/Orders'

Vue.use(VueRouter) 

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,   
    meta: {
      public: true,  // Have access without be authenticated
      onlyWhenLoggedOut: true // not access to login if user is authenticated
    }
  },
  {
    path: '/AccountExpired',
    name: 'AccountExpired',
    component: AccountExpired,
    meta: {
      public: true,  // Have access without be authenticated
      onlyWhenLoggedOut: true // not access to login if user is authenticated
    }
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized,
    meta: {
      public: true,  // Have access without be authenticated
      onlyWhenLoggedOut: true // not access to login if user is authenticated
    }
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: ForgotPassword,
    meta: {
      public: true,  // Have access without be authenticated
      onlyWhenLoggedOut: true // not access to login if user is authenticated
    }
  },

  {
    path: "/recoverypassword/",
    name: 'recoveryPassword',
    component: RecoveryPassword,
    props: (route) => ({ token: route.query.token}), 
    meta: {
      public: true,  // Have access without be authenticated
      onlyWhenLoggedOut: true // not access to login if user is authenticated
    },
    
  },

  {
    path: '/accessdenied',
    name: 'AccessDenied',
    component: AccessDenied,
    meta: {
      public: true,
    }
  },
  {
    path: '/provider',
    name: 'Provider',
    component: Provider,
  },  
  {
    path: '/docs',
    name: 'docs', 
  },  

  {
    path: '/app',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: 'methodnotallowed',
        name: 'methodnotallowed',
        component: MethodNotAllowed,       
      }, 
      {
        path: 'main',
        name: 'Main',
        component: Main,       
      },   
      {
        path: 'setupcompanies',
        name: 'icompany',
        component: IniCompany,       
      },
      {
        path: 'setupreferral',
        name: 'ireferral',
        component: IniReferralList,       
      },
       {
        path: "setupreferral/add",
        name: 'ireferraladd',
        component: IniReferral,
        props: {editMode: false}
      },
      {
        path: "setupreferral/:id/edit",
        name: 'ireferraldetail',
        component: IniReferral,
        props: {editMode: true}
      },
     /* {
        path: 'setupproviders',
        name: 'iproviders',
        component: IniProviders,       
      }, 
      {
        path: 'setuproles',
        name: 'iroles',
        component: IniRoles,       
      },  */
      
      {
        path: 'setupinsurance',
        name: 'iinsurance',
        component: IniInsurance,       
      }, 
      {
        path: 'setupusers',
        name: 'iusers',
        component: IniUsersList,       
      }, 
      {
        path: "setupusers/add",
        name: 'iuseradd',
        component: IniUsers,
        props: {editMode: false}
      },
      {
        path: "setupusers/:id/edit",
        name: 'iuserdetail',
        component: IniUsers,
        props: {editMode: true}
      },

      {
        path: 'setupprograms',
        name: 'iprograms',
        component: IniPrograms,       
      }, 
      {
        path: 'setupnotes',
        name: 'inotes',
        component: IniNotes,       
      },  
      {
        path: 'setuptherapies',
        name: 'itherapies',
        component: IniTherapies,       
      }, 
      {
        path: 'setupapptypes',
        name: 'iapptypes',
        component: IniAppTypes,       
      }, 
      {
        path: 'setupreviewsubmit',
        name: 'ireviewsubmit',
        component: IniReviewSubmit,       
      },    
      {
        path: 'patients',
        name: 'patients-list',
        component: PatientsList,
      },
      {
        path: 'mars',
        name: 'mars-list',
        component: MarsList,
      },
      {
        path: "mars/:id",
        name: 'patient-marsMed',
        component: MarsPatientMed,        
       // props: route => ({ id: route.query.id})    
      },
      {
        path: 'dcs',
        name: 'dcs-list',
        component: DcsList,
      },
      {
        path: "dcs/add",
        name: 'dcs-add',
        component: Dcs,
        props: {editMode: false}
      },
      {
        path: "dcs/upload",
        name: 'dcs-upload',
        component: DcsUpload,
        props: {editMode: false}
      },
      {
        //DCSView
        path: "dcs/:groupId/:year/:month/:monthNumber/:version/:totalcharges/:transactions/:invoice/detail",
        name: 'dcs-detail',
        component: DCSView,
        props: {editMode: true}
      },
      {
        path: 'postPayment',
        name: 'postPayment',
        component: PostPayment,
      },
      {
        path: 'claimStatus',
        name: 'claimBatchStatus',
        component: ClaimBatchStatus
      },
      {
        path: 'insurances',
        name: 'insuranceSetupList',
        component: InsuranceSetupList,
      },
      {
        path: 'patients/:id/claim',
        name: 'patientclaimList',
        component: PatientClaim,
      },
      {
        path: "patients/:id/claim/edit/:claimId",
        name: 'claim-details',
        component: Claim,
        props: {editMode: true}
      },
      {
        path: "patients/:id/claim/add",
        name: 'claim-add',
        component: Claim,
        props: {editMode: false}
      },
      {
        path: "insurances/:id/edit",
        name: 'insurances-details',
        component: InsuranceSetup,
        props: {editMode: true}
      },
      {
        path: "insurances/add",
        name: 'insurances-add',
        component: InsuranceSetup,
        props: {editMode: false}
      },
      {
        path: 'doctors',
        name: 'doctorSetup',
        component: DoctorSetup,
      },
      {
        path: "doctors/:id/edit",
        name: 'doctor-details',
        component: Doctor,
        props: {editMode: true}
      },
      {
        path: "doctors/add",
        name: 'doctor-add',
        component: Doctor,
        props: {editMode: false}
      },
      {
        path: 'claimbatch',
        name: 'claimbatch-list',
        component: ClaimBatch,
      },
      {
        path: 'billingclearinghousefile',
        name: 'createclearinghousefile-list',
        component: CreateClearingHF,
      },
      {
        path: "claimbatch/summary/:id",
        name: 'claimbatch-summary',
        component: ClaimBatchSummary,
        props: {editMode: true}
      },
      {
        path: 'manageclaimbatches',
        name: 'manageclaimbatches-list',
        component: ManageClaimBatches,
      },
      {
        path: 'cpt',
        name: 'hcpcscpt',
        component: HcpcsCptRevCode,
      },
      {
        path: 'modifiers',
        name: 'modifier-list',
        component: ModifiersList,
      },
      {
        path: 'placeofservices',
        name: 'placeofservice-List',
        component: PlaceofServiceList,
      },
      {
        path: "patients/:id/patientinfo",
        name: 'patient-details',
        component: Patient,
        props: {editMode: true}
      },
      {
        path: "patients/summary/:id",
        name: 'patient-summary',
        component: PatientSummary,
        props: {editMode: true}
      },
      {
        path: 'patients/add',
        name: 'patient-add',
        component: Patient,
        props: {editMode: false}
      },
      {
        path: 'patients/:id/generalnotes',
        name: 'patient-generalnotes',
        component: GeneralNotes,
        props: {editMode: true}
      },
      {
        path: 'patients/:id/asam',
        name: 'patient-asam',
        component: PatientAsam,
        props: {editMode: true}
      },
      {
        path: 'patients/:id/contacts',
        name: 'patient-contacts',
        component: ContactsList,
        props: {editMode: true}
      },
      {
        path: 'patients/:id/diagnosis',
        name: 'patient-diagnosis',
        component: Diagnosis,
       // props: {editMode: true}
      },
      {
        path: 'appointments/:id/diagnosis/:actId',
        name: 'appointments-diagnosis',
        component: Diagnosis,
      },
      {
        path: 'clinical/:id/diagnosis/:recordid',
        name: 'Clinical-diagnosis',
        component: Diagnosis,      
      },
      {
        path: 'clinical/:id/insurances/:recordid',
        name: 'Clinical-insurance',
        component: Insurance        
      },
      {
        path: 'clinical/insurance-details/:id/:recordid/:idInsurance',
        name: 'Clinical-insurance-details',
        component: InsuranceDetails,
        props: {editMode: true}        
      },
      {
        path: 'clinical/add-insurance/:id/:recordid',
        name: 'add-Clinical-insurance',
        component: InsuranceDetails,
        props: {editMode: false}        
      },     
      {
        path: 'clinical/:id/allergies/:recordid',
        name: 'Clinical-allergies',
        component: AllergiesList,   
      },

      {
        path: 'clinical/:id/allergies/:allergyid/:recordid',
        name: 'Clinical-allergies-details',
        component: Allergy,
        props: {editMode: true}        
      },
      {
        path: 'clinical/:id/allergies/:recordid',
        name: 'Clinical-allergies-Add-details',
        component: Allergy,
        props: {editMode: false}        
      },
      /*{
        path: 'clinical/add-insurance/:id/:recordid',
        name: 'add-Clinical-insurance',
        component: InsuranceDetails,
        props: {editMode: false}        
      },*/
      {
        path: 'clinical/:id/contacts/:recordid',
        name: 'Clinical-cont',
        component: ContactsList
      },
      {
        path: "clinical/:id/contacts/:contactid/:recordid",
        name: 'Clinical-cont-details',
        component: Contacts,
        props: {editMode: true}
      },
      {
        path: "clinical/:id/contact-add/:recordid",
        name: 'Clinical-cont-add',
        component: Contacts,
        props: {editMode: false}
      },
      {
        path: 'clinical/:id/document/:recordid',
        name: 'Clinical-document',
        component: DocumentManagementList      
      },
      {
        path: "clinical/:id/document/:seqNo/:recordid",
        name: 'Clinical-document-detail',
        component: DocumentManagement,
        props: {editMode: true}
      },
      {
        path: "clinical/:id/document-add/:recordid",
        name: 'Clinical-document-add',
        component: DocumentManagement,
        props: {editMode: false}
      },
      {
        path: 'patients/:id/admission',
        name: 'patient-admissionList',
        component: AdmissionList,
        props: {editMode: true}
      },
      {
        path: "patients/:id/admission/add",
        name: 'patient-admission-add',
        component: AdmissionAdd,
        props: {editMode: false}
      },
      {
        path: "patients/:id/admission/:recordid",
        name: 'patient-admission-edit',
        component: AdmissionAdd,
        props: {editMode: true}
      },
      {
        path: 'appointments/:id/admission/:actId',
        name: 'appointments-admissionList',
        component: AdmissionList,
        props: {editMode: true}
      },
      {
        path: "appointments/:id/admission/add/:actId",
        name: 'appointments-admission-add',
        component: AdmissionAdd,
        props: {editMode: false}
      },
      {
        path: "appointments/:id/admission/:recordid/:actId",
        name: 'appointments-admission-edit',
        component: AdmissionAdd,
        props: {editMode: true}
      },
      {
        path: 'appointments/:id/allergies/:actId',
        name: 'appointments-allergies',
        component: AllergiesList,
      },
      {
        path: 'appointments/:id/insurances/:actId',
        name: 'appointments-insurance',
        component: Insurance,
      },
      {
        path: "appointments/:id/allergies/:allergyid/:actId",
        name: 'appointments-allergy-details',
        component: Allergy,
        props: {editMode: true}
      },
      {
        path: "appointments/:id/allergy-add/:actId",
        name: 'appointments-allergy-add',
        component: Allergy,
        props: {editMode: false}
      },
      {       
        path: 'clinical/:id/admission/:recordid',
        name: 'admission-clinical',
        component: AdmissionClinical,
        props: {editMode: true}
      },
      {
        path: "patients/:id/contacts/:contactid",
        name: 'contact-details',
        component: Contacts,
        props: {editMode: true}
      },
      {
        path: "patients/:id/contact-add",
        name: 'patient-contact-add',
        component: Contacts,
        props: {editMode: false}
      },
      {
        path: 'appointments/:id/contacts/:actId',
        name: 'appointments-contacts',
        component: ContactsList,
        props: {editMode: true}
      },
      {
        path: "appointments/:id/contacts/:contactid/:actId",
        name: 'appointments-contact-details',
        component: Contacts,
        props: {editMode: true}
      },
      {
        path: "appointments/:id/contact-add/:actId",
        name: 'appointments-contact-add',
        component: Contacts,
        props: {editMode: false}
      },
      {
        path: 'patients/:id/insurances',
        name: 'patient-insurance',
        component: Insurance,
        props: {editMode: true}
      },
      {
        path: 'patients/:id/document',
        name: 'patient-document',
        component: DocumentManagementList      
      },
      {
        path: "patients/:id/document/:seqNo",
        name: 'patient-document-detail',
        component: DocumentManagement,
        props: {editMode: true}
      },
      {
        path: "patients/:id/document-add",
        name: 'patient-document-add',
        component: DocumentManagement,
        props: {editMode: false}
      },
      {
        path: 'appointments/:id/document/:actId',
        name: 'appointments-document',
        component: DocumentManagementList      
      },
      {
        path: "appointments/:id/document/:seqNo/:actId",
        name: 'appointments-document-detail',
        component: DocumentManagement,
        props: {editMode: true}
      },
      {
        path: "appointments/:id/document-add/:actId",
        name: 'appointments-document-add',
        component: DocumentManagement,
        props: {editMode: false}
      },
      {
        path: 'patients/insurance-details/:id/:idInsurance',
        name: 'patient-insurance-details',
        component: InsuranceDetails,
        props: {editMode: true}        
      },
      {
        path: 'patients/add-insurance/:id',
        name: 'add-patient-insurance',
        component: InsuranceDetails,
        props: {editMode: false}        
      },
      {
        path: 'appointments/:id/insurances/:actId',
        name: 'appointments-Insurance',
        component: Insurance,
        props: {editMode: true}
      },
      {
        path: 'appointments/insurance-details/:id/:idInsurance/:actId',
        name: 'appointments-insurance-details',
        component: InsuranceDetails,
        props: {editMode: true}        
      },
      {
        path: 'appointments/add-insurance/:id/:actId',
        name: 'add-appointments-insurance',
        component: InsuranceDetails,
        props: {editMode: false}        
      },
      {
        path: 'clinical',
        name: 'Clinical',
        component: Clinical,       
      },
      {
        path: 'clinicalnotes',
        name: 'clinicalNotesContainer',
        component: ClinicalNotesContainer,       
      },
      {
        path: 'clinical/:id/dashboard/:recordid',
        name: 'Clinical-Dashboard',
        component: ClinicalDashBoard,       
      },
      {
        path: 'appointments/:id/dashboard/:actId',
        name: 'appointment-Dashboard',
        component: AppointmentDashBoard,       
      },
      {
        path: 'clinical/:id/patientinfo/:recordid',
        name: 'Clinical-PatientInfo',
        component: ClinicalPatientInfo,
        props: {editMode: true}       
      },
      {
        path: 'clinical/:id/notes/:recordid',
        name: 'Clinical-Notes',
        component: ClinicalNotes,       
      },
      {
        path: 'clinical/:id/chartreview/:recordid',      
        name: 'Clinicalchartreview',
        component: ChartReviewClinical,       
      },
      {
        path: 'patients/:id/chartreview',
        name: 'patientchartreview',
        component: ChartReviewPatient,       
      },
      {
        path: 'appointments/:id/chartreview/:actId',
        name: 'appointments-chartreview',
        component: ChartReviewPatient,       
      },
      {
        path: 'patients/:id/ePharmacy',
        name: 'patientePharmacy',
        component: ePharmacyPatient,       
      },
      {
        path: 'clinical/:id/ePharmacy/:recordid',
        name: 'clinicalePharmacy',
        component: ePharmacyClinical,       
      },
      {
        path: 'clinical/:id/asam/:recordid',
        name: 'Clinical-Asam',
        component: ClinicalAsam,       
      },
      {
        path: 'patients/:id/allergies',
        name: 'patient-allergies',
        component: AllergiesList,
      },
      {
        path: "patients/:id/allergies/:allergyid",
        name: 'allergy-details',
        component: Allergy,
        props: {editMode: true}
      },
      {
        path: 'clinical/:id/allergies/:recordid',
        name: 'Clinical-PatientAllergies',
        component: AllergiesList,   
      },
      {
        path: 'clinical/:id/transfer/:recordid',
        name: 'Clinical-Transfer',
        component: Transfer,   
      },
      // Wiley Treatment Plan
      {
        path: 'clinical/:id/wytreatmentplan/:recordid/:notesid',
        name: 'WyTreatmentplan-Clinical',
        component: WyTreatmentPlanList,   
      },
      {
        path: 'appointments/:id/wytreatmentplan/:recordid/:notesid',
        name: 'WyTreatmentplan-Appointment',
        component: WyTreatmentPlanList,   
      },
      {
        path: "clinical/:id/wytreatmentplan/:recordid/:problemid",
        name: 'WyTreatmentplan-details-Clinical',
        component: WyTreatmentPlan,
        props: {editMode: true}
      },
      {
        path: "clinical/:id/wytreatmentplan/:recordid/add/:notesid",
        name: 'WyTreatmentplan-add-Clinical',
        component: WyTreatmentPlan,
        props: {editMode: false}
      },
      {
        path: "appointments/:id/wytreatmentplan/:recordid/add/:notesid",
        name: 'WyTreatmentplan-add-Appointment',
        component: WyTreatmentPlan,
        props: {editMode: false}
      },
      // MedEZ Treatment Plan
      {
        path: 'clinical/:id/mdtreatmentplan/:recordid/:notesid',
        name: 'MdTreatmentplan-Clinical',
        component: MdTreatmentPlanList,   
      },
      {
        path: 'appointments/:id/mdtreatmentplan/:recordid/:notesid',
        name: 'MdTreatmentplan-Appointment',
        component: MdTreatmentPlanList,   
      },
      {
        path: "clinical/:id/mdtreatmentplan/:recordid/:problemid",
        name: 'MdTreatmentplan-details-Clinical',
        component: MdTreatmentPlan,
        props: {editMode: true}
      },
      {
        path: "clinical/:id/mdtreatmentplan/:recordid/add/:notesid",
        name: 'MdTreatmentplan-add-Clinical',
        component: MdTreatmentPlan,
        props: {editMode: false}
      },
      {
        path: "appointments/:id/mdtreatmentplan/:recordid/add/:notesid",
        name: 'MdTreatmentplan-add-Appointment',
        component: MdTreatmentPlan,
        props: {editMode: false}
      },
      

      {
        path: 'clinical/:id/treatmentplan/:recordid',
        name: 'treatmentplanbase-Clinical',
        component: TPBase,   
      },

      {
        path: 'appointments/:id/treatmentplan/:actId',        
        name: 'treatmentplanbase-Scheduler',
        component: TPBase,   
      },

      {
        path: 'clinical/:id/discharge/:recordid',
        name: 'Clinical-Discharge',
        component: Discharge,   
      },
      {
        path: "clinical/:id/allergy-add/:recordid",
        name: 'Clinical-allergies-add',
        component: Allergy,
        props: {editMode: false}
      },
      {
        path: "patients/:id/allergy-add",
        name: 'patient-allergy-add',
        component: Allergy,
        props: {editMode: false}
      },
      {
        path: 'clinical/:id/vital/:recordid',
        name: 'Clinical-vital-sign',
        component: VitalSignList,       
      }
      ,{
        path: "clinical/:id/vs-add/:recordid",
        name: 'vs-add',
        component: VitalSign,
        props: {editMode: false}
      },
      {
        path: "clinical/:id/vital/:recordid/:vsid",
        name: 'vs-details',
        component: VitalSign,
        props: {editMode: true}
      },
      {
        path: 'appointments/:id/vital/:actId',
        name: 'appointments-vital-sign',
        component: VitalSignList,       
      },
      {
        path: "appointments/:id/vs-add/:actId",
        name: 'appointments-vs-add',
        component: VitalSign,
        props: {editMode: false}
      },
      {
        path: "appointments/:id/vital/:vsid/:actId",
        name: 'appointments-vs-details',
        component: VitalSign,
        props: {editMode: true}
      },
      {
        path: 'clinical/:id/medications/:recordid',
        name: 'Clinical-Medications',
        component: MedicationsList,       
      },
      {
        path: "clinical/:id/addmedications/:recordid",
        name: 'Clinical-medications-add',
        component: Medications,
        props: {editMode: false}
      },
      {
        path: "clinical/:id/medications/:recordid/code/:recId",
        name: 'Clinical-medications-details',
        component: Medications,
        props: {editMode: true}
      },
      {
        path: "clinical/:id/standing-orders/:recordid",
        name: 'Clinical-medications-standing-orders',
        component: StandingOrders,
      },
      {
        path: 'appointments/:id/medications/:actId',
        name: 'Appointments-Medications',
        component: MedicationsList,       
      },
      {
        path: "appointments/:id/addmedications/:actId",
        name: 'Appointments-medications-add',
        component: Medications,
        props: {editMode: false}
      },
      {
        path: "appointments/:id/medications/code/:recId/:actId",
        name: 'Appointments-medications-details',
        component: Medications,
        props: {editMode: true}
      },
      {
        path: "appointments/:id/standing-orders/:actId",
        name: 'Appointments-medications-standing-orders',
        component: StandingOrders
      },
     
      {
        path: 'clinical/:id/dailynote/:recordid',
        name: 'Clinical-daily-note',
        component: DailyNotesList,       
      },
      {
        path: "clinical/:id/dailynote/:recordid/:dailynoteid/:noteTypeName/:noteEmployeeCode",
        name: 'dailynote-details',
        component: DailyNote,
        props: {editMode: true}
      },
      {
        path: "clinical/:id/dailynote-add/:recordid/:notetype/:noteTypeName",
        name: 'dailynote-add',
        component: DailyNote,
        props: {editMode: false}
      },
      {
        path: 'clinical/:id/lognote/:recordid',
        name: 'Clinical-log-note',
        component: LogNotesList,       
      },
      {
        path: "clinical/:id/lognote/:recordid/:lognoteid/:intakedate/:noteTypeName",
        name: 'lognote-details',
        component: LogNote,
        props: {editMode: true}
      },
      {
        path: "clinical/:id/lognote-add/:recordid/:lognoteid/:noteTypeName",
        name: 'lognote-add',
        component: LogNote,
        props: {editMode: false}
      },
      {
        path: 'employeeinbox',
        name: 'Clinical-employee-inbox',
        component: EmployeeInbox,       
      },
      {
        path: 'scheduler',
        name: 'scheduler',
        component: Schedule,
      },
      {
        path: 'schedule-editor',
        name: 'schedule-editor',
        component: ScheduleEditor,
      },
      {
        path: 'reportbuilder',
        name: 'reportbuilder',
        component: ReportBuilder,
      },
      {
        path: 'roles',
        name: 'roles',
        component: UserTemplateHeaderList
      },
      {
        path: "roles/:id/edit",
        name: 'role-details',
        component: UserRole,
        props: {editMode: true, clone: false}
      },
      {
        path: "roles/add",
        name: 'role-add',
        component: UserRole,
        props: {editMode: false}
      },
      {
        path: "roles/:id/clone",
        name: 'role-clone',
        component: UserRole,
        props: {editMode: false, clone: true}
      },
      {
        path: 'users',
        name: 'users',
        component: UserHeaderList
      },
      {
        path: "users/:id/edit",
        name: 'users-details',
        component: UserHeader,
        props: {editMode: true}
      },
      {
        path: "users/add",
        name: 'users-add',
        component: UserHeader,
        props: {editMode: false}
      },
      {
        path: "cpt/:id/edit",
        name: 'cpt-details',
        component: CPT,
        props: {editMode: true}
      },
      {
        path: "cpt/add",
        name: 'cpt-add',
        component: CPT,
        props: {editMode: false}
      },
      {
        path: "modifiers/:id/edit",
        name: 'modifiers-details',
        component: Modifiers,
        props: {editMode: true}
      },
      {
        path: "modifiers/add",
        name: 'modifiers-add',
        component: Modifiers,
        props: {editMode: false}
      },
      {
        path: "placeofservices/:id/edit",
        name: 'placeofservices-details',
        component: PlaceofService,
        props: {editMode: true}
      },
      {
        path: "placeofservices/add",
        name: 'placeofservices-add',
        component: PlaceofService,
        props: {editMode: false}
      },
      {
        path: 'employeetypes',
        name: 'employeeTypeList',
        component: EmployeeTypeList,
      },
      {
        path: "employeetypes/:id/edit",
        name: 'employeeType-details',
        component: EmployeeType,
        props: {editMode: true}
      },
      {
        path: "employeetypes/add",
        name: 'employeeType-add',
        component: EmployeeType,
        props: {editMode: false}
      },
      {
        path: 'valuecodes',
        name: 'valuecodesList',
        component: ValueCodeList,
      },
      {
        path: "valuecodes/:id/edit",
        name: 'valuecode-details',
        component: ValueCode,
        props: {editMode: true}
      },
      {
        path: "valuecodes/add",
        name: 'valuecode-add',
        component: ValueCode,
        props: {editMode: false}
      },
      {
        path: 'rooms',
        name: 'roomsList',
        component: RoomsList,
      },
      {
        path: "rooms/:id/edit",
        name: 'rooms-details',
        component: Rooms,
        props: {editMode: true}
      },
      {
        path: "rooms/add",
        name: 'rooms-add',
        component: Rooms,
        props: {editMode: false}
      },
      {
        path: 'buildings',
        name: 'buildingsList',
        component: BuildingList,
      },
      {
        path: "buildings/:id/edit",
        name: 'buildings-details',
        component: Building,
        props: {editMode: true}
      },
      {
        path: "buildings/add",
        name: 'buildings-add',
        component: Building,
        props: {editMode: false}
      },

      {
        path: 'employeecredentials',
        name: 'employeecredentialsList',
        component: EmployeeCredentialList,
      },
      {
        path: "employeecredentials/:id/edit",
        name: 'employeecredentials-details',
        component: EmployeeCredential,
        props: {editMode: true}
      },
      {
        path: "employeecredentials/add",
        name: 'employeecredentials-add',
        component: EmployeeCredential,
        props: {editMode: false}
      },

      {
        path: 'employees',
        name: 'employeeList',
        component: EmployeeList,
      },
      {
        path: "employees/:id/edit",
        name: 'employee-details',
        component: Employee,
        props: {editMode: true}
      },
      {
        path: "employees/add",
        name: 'employee-add',
        component: Employee,
        props: {editMode: false}
      },

      {
        path: 'appointmenttypes',
        name: 'appointmenttypesList',
        component: AppoinmentTypeList,
      },
      {
        path: "appointmenttypes/:id/edit",
        name: 'appointmenttypes-details',
        component: AppoinmentType,
        props: {editMode: true}
      },
      {
        path: "appointmenttypes/add",
        name: 'appointmenttypes-add',
        component: AppoinmentType,
        props: {editMode: false}
      },

      {
        path: 'calendarresources',
        name: 'calendarresourcesList',
        component: CalendarResourcesList,
      },
      {
        path: 'appointments',
        name: 'appointments',
        component: SchedulerDB,
      },
      {
        path: "calendarresources/:id/edit",
        name: 'calendarresources-details',
        component: CalendarResources,
        props: {editMode: true}
      },
      {
        path: "calendarresources/add",
        name: 'calendarresources-add',
        component: CalendarResources,
        props: {editMode: false}
      },
      {
        path: 'clinicalnotesreport',
        name: 'reportClinicalNotes',
        component: ReportClinicalNotes,
      },
      {
        path: 'reports/favorites',
        name: 'reportList',
        component: ReportList,
        props: {mode: 'favorites'}
      },
      {
        path: 'reports/notes',
        name: 'reportListNotes',
        component: ReportList,
        props: {category: 'Notes'}
      },
      {
        path: 'reports/billing',
        name: 'reportListBilling',
        component: ReportList,
        props: {category: 'Billing'}
      },
      {
        path: 'reports/patients',
        name: 'reportListPatient',
        component: ReportList,
        props: {category: 'Patients'}
      },
      {
        path: 'reports/powerbi',
        name: 'reportListPowerBI',
        component: PowerBILayout,
        props: {category: 'Power BI'}
      },
      {
        path:'reports/:type/:id/powerbi/:name',
        name: 'PowerBI-Report',
        component: PowerBIReport,
      },
      {
        path: 'dailyservicechargesreport',
        name: 'DailyServiceCharge',
        component: DailyServiceCharge,
      },
      {
        path: 'dailyservicelogreport',
        name: 'DailyServiceLog',
        component: DailyServiceLog,
      },
      {
        path: 'groupnotes',
        name: 'groupnotes',
        component: GroupNotes,
      },
      {
        path: 'groupnotes/:id',
        name: 'groupnotes-Dashboard',
        component: GroupNotesAccordion,       
      },
      {
        path: 'appointments/:id/schedulernotes/:actId',
        name: 'scheduler-appointment-notes',
        component: SchedulerNotes,       
      },
      {
        path: 'incidents',
        name: 'incident-report',
        props: {keepFilter: false},
        component: IncidentReport,       
      },
      {
        path: 'incidents',
        name: 'incident-report-back',
        props: {keepFilter: true},
        component: IncidentReport,       
      },
      {
        path: 'incident-detail/:IncidentID',
        name: 'incident-content',
        props: {editMode: true},
        component: IncidentReportContent,       
      },
      {
        path: 'incident-detail',
        name: 'incident-report-general-info-add',
        props: {editMode: false},      
        component: IncidentReportContent,       
      },
      {
        path: 'druglist',
        name: 'DrugList',
        component: DrugList,       
      },
      {
        path: 'drug',
        name: 'Drug',
        component: Drug,       
      },
      {
        path: "drugs/:id/edit",
        name: 'drug-details',
        component: Drug,
        props: {editMode: true}
      },
      {
        path: "drugs/add",
        name: 'drug-add',
        component: Drug,
        props: {editMode: false}
      },
      {
        path: 'patientcontactsreport',
        name: 'PatientContactsRep',
        component: PatientContactsRep,
        props: {filterView: true, recNo: null, patientCode: null},
      },
      {
        path: 'patientallergiesreport',
        name: 'PatientAllergyRep',
        component: PatientAllergyRep,
        props: {filterView: true, recNo: null, patientCode: null},
      },
      {
        path: 'patientinsurancesreport',
        name: 'PatientInsurancesRep',
        component: PatientInsurancesRep,
        props: {showModal: true, RecNo: null, PatientCode: null},
      },
      {
        path: 'specialprecautionsreport',
        name: 'SpecialPrecautionsRep',
        component: SpecialPrecautionsRep,
        props: {showModal: true,  PatientCode: null},
      },
      {
        path: 'icrmultiplerep',
        name: 'ICRMultipleViewRep',
        component: ICRMultipleViewRep,
      },
      {
        path: 'employeecaseloadreport',
        name: 'reportEmployeeCaseLoad',
        component: ReportEmployeeCaseLoad,
      },
      {
        path: 'schedulerdailyfiltersrep',
        name: 'schedulerDailyFiltersRep',
        component: schedulerDailyFiltersRep,
      },
      {
        path: 'patientalertsreport',
        name: 'PatientAlertFiltersRep',
        component: PatientAlertFiltersRep,
      },
      {
        path: 'patientactreport',
        name: 'PatientActivityFiltersRep',
        component: PatientActivityFiltersRep,
      },
      {
        path: 'patientmedreport',
        name: 'PatientMedicationFiltersRep',
        component: PatientMedicationFiltersRep,
      },
      {
        path: 'marsalertsreport',
        name: 'PatientMarsAlertsRep',
        component: PatientMarsAlertsRep,
        props: {showModal: true,  PatientCode: null},
      },
      {
        path: 'reports/employeecaseload',
        name: 'reportListEmployeeCaseLoad',
        component: ReportList,
        props: {category: 'EmployeeCaseLoad'}
      },
      {
        path: 'incidentsworkflow',
        name: 'IncidentWorkflow',
        component: IncidentWorkflow,
      },
      {
        path: 'clinical/:id/scheduler/:recordid',
        name: 'SchedulerClinical',
        component: SchedulerClinical,
      },
      {
        path: "patients/:id/appointments",
        name: 'patient-appoint',
        component: Appointments,
        props: {editMode: true}
      }, 
      {
        path: "clinical/:id/appointments/:recordid",
        name: 'clinical-appoint',
        component: Appointments,
        props: {clinical: true}
      },
      {
        path: 'appointments/:id/patientinfo/:actId',
        name: 'Appointments-PatientInfo',
        component: Patient,
        props: {editMode: true}       
      },
      {
        path: 'appointments/:id/editor/:actId',
        name: 'Appointment-Editor',
        component: AppointmentEditor,
        props: {editMode: true}       
      },
      {
        path: 'appointments/editor/add',
        name: 'Appointment-Editor-Add',
        component: AppointmentEditor,
        props: {editMode: false}       
      },
      {
        path: 'appointments/:id/asam/:actId',
        name: 'appointments-asam',
        component: PatientAsam,
        props: {editMode: true}
      },
      {
        path: 'appointments/:id/discharge/:actId',
        name: 'appointments-discharge-admission',
        component: ScheduleDBAdmission,
      },
      {
        path: 'appointments/:id/discharge/:actId/:recordid',
        name: 'appointments-discharge',
        component: Discharge,   
      },
      {
        path: 'appointments/:id/transfer/:actId',
        name: 'appointments-transfer-admission',
        component: ScheduleDBAdmission,
      },
      {
        path: 'appointments/:id/transfer/:actId/:recordid',
        name: 'appointments-transfer',
        component: Transfer,   
      },
      {
        path: 'appointments/:id/ePharmacy/:actId',
        name: 'appointments-epharmacy',
        component: ePharmacyClinical,       
      },  
      {
        path: 'clinical/:id/special-precautions/:recordid',
        name: 'Clinical-special-precautions',
        component: EditSpecialPrecautions,        
      },
      {
        path: 'patients/:id/special-precautions',
        name: 'patient-special-precautions',
        component: EditSpecialPrecautions,
      },
      {
        path: 'patients/:id/discharges',
        name: 'patient-discharges',
        component: PatientDischargesListing,
      },
      {
        path: "patients/:id/discharge/:recordid",
        name: 'patient-discharge-edit',
        component: Discharge,
        props: {editMode: true}
      },
      {
        path: "appointments/:id/special-precautions/:actId",
        name: 'appointments-special-precautions',
        component: EditSpecialPrecautions,
      },
      {
        path: 'allergylist',
        name: 'allergyList',
        component: AllergySetupList,       
      },
      {
        path: "allergy-setup/:id/edit",
        name: 'allergy-setup-details',
        component: AllergySetup,
        props: {editMode: true}
      },
      {
        path: "allergy-setup/add",
        name: 'allergy-setup-add',
        component: AllergySetup,
        props: {editMode: false}
      },
      {
        path: "admissionsrep",
        name: 'AdmissionsRep',
        component: AdmissionsViewRep,
      },
      {
        path: 'clinical/:id/mars-alerts/:recordid',
        name: 'Clinical-mars-alerts',
        component: EditMarsAlert,        
      },
      {
        path: 'patients/:id/mars-alerts',
        name: 'patient-mars-alerts',
        component: EditMarsAlert,
      },
      {
        path: "appointments/:id/mars-alerts/:actId",
        name: 'appointments-mars-alerts',
        component: EditMarsAlert,
      },
      {
        path: 'clinical/:id/patient-alerts/:recordid',
        name: 'Clinical-patient-alerts',
        component: PatientAlertList,        
      },
      {
        path: 'patients/:id/alerts',
        name: 'patient-alerts',
        component: PatientAlertList,
      },
      {
        path: "appointments/:id/patient-alerts/:actId",
        name: 'appointments-alerts',
        component: PatientAlertList,
      },
      {
        path: 'clinical/:id/add-patient-alert/:recordid',
        name: 'Clinical-patient-alert-add',
        component: EditPatientAlert,  
        props: {editMode: false}      
      },
      {
        path: 'patients/:id/add-alert',
        name: 'patient-alert-add',
        component: EditPatientAlert,
        props: {editMode: false}
      },
      {
        path: "appointments/:id/add-patient-alert/:actId",
        name: 'appointments-alert-add',
        component: EditPatientAlert,
        props: {editMode: false}
      },
      {
        path: 'clinical/:id/edit-patient-alert/:recordid/code/:code',
        name: 'Clinical-patient-alert-edit',
        component: EditPatientAlert,  
        props: {editMode: true}      
      },
      {
        path: 'patients/:id/edit-alert/:code',
        name: 'patient-alert-edit',
        component: EditPatientAlert,
        props: {editMode: true}
      },
      {
        path: "appointments/:id/edit-patient-alert/:actId/code/:code",
        name: 'appointments-alert-edit',
        component: EditPatientAlert,
        props: {editMode: true}
      },
      {
        path: "patientmarsrep",
        name: 'PatientMarsRep',
        component: patientMarsRep,
      },
      {       
        path: 'clinical/:id/activity/:recordid',
        name: 'Clinical-activities',
        component: PatientActivitiesList,       
      },  
      {
        path: 'clinical/:id/add-activity/:recordid',
        name: 'clinical-add-activity',
        props: {editMode: false},
        component: PatientActivity,       
      },
      {
        path: 'clinical/:id/edit-activity/:recordid/code/:code',
        name: 'clinical-edit-activity',
        props: {editMode: true},
        component: PatientActivity,       
      },
      {
        path: 'patients/:id/activities',
        name: 'patient-activities',
        component: PatientActivitiesList,
      },
      {
        path: 'patients/:id/add-activity',
        name: 'patient-add-activity',
        component: PatientActivity,
        props: {editMode: false}
      },
      {
        path: 'patients/:id/edit-activity/:code',
        name: 'patient-edit-activity',
        component: PatientActivity,
        props: {editMode: true}
      },
      {
        path: 'appointments/:id/activities/:actId',
        name: 'schedulerdb-activitiesList',
        component: PatientActivitiesList,       
      },  
      {
        path: 'appointments/:id/activities/:actId/add',
        name: 'schedulerdb-activitiesAdd',
        props: {editMode: false},
        component: PatientActivity,       
      },
      {
        path: 'appointments/:id/activities/:actId/:code/edit',
        name: 'schedulerdb-activitiesEdit',
        props: {editMode: true},
        component: PatientActivity,       
      },
      {
        path: 'tools/audit',
        name: 'auditListing',
        component: AuditListing,       
      },
      {
        path: 'tools/audit-setting',
        name: 'auditSettingListing',
        component: AuditSettingListing,       
      },
      {
        path: 'customexports',
        name: 'customExportsList',
        component: CustomExportsList,
      },
      {
        path: 'customexports/:id',
        name: 'customExports',
        component: CustomExports,
      },
      {
        path: 'customreports',
        name: 'customReports',
        component: CustomReports,
      },
      {
        path: 'chargesheet',
        name: 'chargesheet',
        component: ChargeSheet,
      },
      {
        path: 'chargesheet-detail/:id',
        name: 'chargesheetdetail',
        component: ChargeSheetDetail,
      },
      {
        path: 'medicationinbox',
        name: 'medicationinbox',
        component: MedicationInbox,
      },
      {
        path: 'patientfacesheetrep',
        name: 'PatientFaceSheetViewRep',
        component: PatientFaceSheetViewRep,
      },
      {
        path: 'patientfacesheetbyadmrep',
        name: 'PatientFaceSheetByAdmissionRep',
        component: PatientFaceSheetByAdmissionRep,
      },
      {       
        path: 'clinical/:id/orders/:recordid',
        name: 'Clinical-orders',
        component: OrdersList,       
      },
            {
        path: "clinical/:id/order-add/:recordid",
        name: 'Clinical-orders-add',
        component: Orders,
        props: {editMode: false}
      },
      {
        path: "clinical/:id/order-detail/:recordid/code/:recId",
        name: 'Clinical-orders-details',
        component: Orders,
        props: {editMode: true}
      },
      {       
        path: 'appointments/:id/orders/:actId',
        name: 'Appointments-orders',
        component: OrdersList,       
      },
      {
        path: "appointments/:id/order-add/:actId",
        name: 'Appointments-orders-add',
        component: Orders,
        props: {editMode: false}
      },
      {
        path: "appointments/:id/order-detail/code/:recId/:actId",
        name: 'Appointments-orders-details',
        component: Orders,
        props: {editMode: true}
      },
    ],
  },
]

// eslint-disable-next-line no-new
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {// eslint-disable-line no-unused-vars
    // We make sure the scroll is always on top 
    return new Promise((resolve) => {
      // Use Vue.nextTick to update the DOM
      Vue.nextTick(() => {
        const container = document.querySelector('.m-pagecontent');
        if (container) {
          container.scrollTop = 0;
        }
        resolve({ x: 0, y: 0 });
      });
    });
  }
})

router.beforeEach((to, from, next) => {  
  const isPublic = to.matched.some(record => record.meta.public);
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);
  const loggedIn = UserService.IsLoged();
  const isAuthenticated = UserService.IsAuthenticated();
  
  // Route it not public and user is not Authenticated
  if (!isPublic && !loggedIn) {   
    return next('/login');
  }

  //User is loged but don´t have select provider
  if (loggedIn && !isAuthenticated && to.fullPath !== '/provider') {    
    return next('/provider');
  }

  // if onlyWhenLoggedOut and user it logged reroute to root
  if (loggedIn && onlyWhenLoggedOut) {   
    return next('/')
  }

  next();
})

export default router;